import{css}from"lit";export default css`
  :host([edit]) agentx-wc-widget-wrapper::part(widget-section) {
    opacity: 0.3;
  }
`;